/** Outer shell of the review glass card: gradient stroke and cast shadow.
 *  Radius is the product token `rounded-glass` (32). */
export const revisaoGlassBorderClass =
  "revisao-glass-border rounded-glass overflow-hidden";

/** Inner face: layered fill, inner light, backdrop blur.
 *  Same layers in both themes; only --c-glass-* / --o-glass-* resolve differently. */
export const revisaoGlassFaceClass =
  "revisao-glass-face flex h-full w-full flex-col p-7";

/** Shared primary action for every review screen.
 *  Fill is `rate-easy` — the frame's lime, identical in both themes.
 *  Ink is `on-lime`, also identical in both themes (about 13:1 on that lime).
 *  Light theme draws a 1px on-lime outline: lime on white is ~1.4:1, under the
 *  3:1 control-boundary floor, and on-lime on white is ~18:1.
 *  Dark theme's border matches the fill; the lime itself is ~12:1 on the dark surface,
 *  and an on-lime outline would disappear against that surface (~1.1:1). */
export const revisaoPrimaryActionClass =
  "inline-flex items-center justify-center rounded-full border border-on-lime bg-rate-easy px-6 min-h-[52px] text-sm font-semibold text-on-lime dark:border-rate-easy";
